import PageTitleComponent from "../PageTitle"
import TagList from "./Actions/TagList"

const Tags = () => {
    return (<div>
        <PageTitleComponent title="Tags"/>
        <TagList/>
    </div>)
}

export default Tags